import React from "react";
import { Button } from "react-bootstrap";
import "react-toggle/style.css";
import AlertComponent from "../AlertComponent";

function AddOrEditMediaPackageOutput(props) {
  const { outputName, handleAddNewElementsOutput } = props;

  const handleAddItem = () => {
    if (!outputName) {
      return AlertComponent("Error", "Output name is required", {
        icon: `error`,
      });
    }

    const item = {
      name: outputName,
      outputType: `MediaPackage`,
    };

    handleAddNewElementsOutput(item);
  };

  return (
    <div>
      <Button className="dark-btn" onClick={handleAddItem}>Add</Button>
    </div>
  );
}

export default AddOrEditMediaPackageOutput;
